"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNNAMED_SLOT_KEY = '!unnamed!';
exports.SLOT_TAG_NAME = 'slot';
exports.RENDER_TARGET_ELEMENT_TAG_NAME = 'render-target';
